(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfc-category-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.sport-hub__quicknav').forEach((nav) => {
    const links = nav.querySelectorAll('[data-quicknav-target]');
    const sections = Array.from(links)
      .map((link) => document.getElementById(link.dataset.quicknavTarget))
      .filter(Boolean);
    if (!sections.length) return;

    const setActive = (id) => {
      links.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.quicknavTarget === id);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    );

    sections.forEach((section) => observer.observe(section));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfc-color-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.sport-hub__preview').forEach((stage) => {
    stage.addEventListener('click', (event) => {
      const swatch = event.target.closest('.sport-hub__preview-swatch');
      if (!swatch) return;
      const row = swatch.closest('.sport-hub__preview-swatch-row');
      const target = document.getElementById(row.dataset.target);
      if (target && swatch.dataset.color) target.style.backgroundColor = swatch.dataset.color;
      row.querySelectorAll('.sport-hub__preview-swatch').forEach((s) => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
    });

    const nameInput = stage.querySelector('[id^="previewTeamInput-"]');
    const nameText = stage.querySelector('[id^="previewTeamName-"]');
    if (nameInput && nameText) {
      nameInput.addEventListener('input', () => {
        nameText.textContent = (nameInput.value || 'TEAM').toUpperCase();
      });
    }

    const numInput = stage.querySelector('[id^="previewNumberInput-"]');
    const numText = stage.querySelector('[id^="previewNumber-"]');
    if (numInput && numText) {
      numInput.addEventListener('input', () => {
        numText.textContent = numInput.value || '00';
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-hub"]) return;
  try {
    
(function () {
  const nav = document.querySelector('.sport-hub__quicknav');
  if (!nav) return;
  const links = nav.querySelectorAll('[data-quicknav-target]');
  const sections = Array.from(links)
    .map((link) => document.getElementById(link.dataset.quicknavTarget))
    .filter(Boolean);
  if (!sections.length) return;

  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.quicknavTarget === id);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    },
    { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));
})();

(function () {
  const stage = document.querySelector('.sport-hub__preview');
  if (!stage) return;

  stage.addEventListener('click', (event) => {
    const swatch = event.target.closest('.sport-hub__preview-swatch');
    if (!swatch) return;
    const row = swatch.closest('.sport-hub__preview-swatch-row');
    const target = document.getElementById(row.dataset.target);
    if (target && swatch.dataset.color) target.style.backgroundColor = swatch.dataset.color;
    row.querySelectorAll('.sport-hub__preview-swatch').forEach((s) => s.classList.remove('is-selected'));
    swatch.classList.add('is-selected');
  });

  const nameInput = stage.querySelector('#previewTeamInput');
  const nameText = stage.querySelector('#previewTeamName');
  if (nameInput && nameText) {
    nameInput.addEventListener('input', () => {
      nameText.textContent = (nameInput.value || 'TEAM').toUpperCase();
    });
  }

  const numInput = stage.querySelector('#previewNumberInput');
  const numText = stage.querySelector('#previewNumber');
  if (numInput && numText) {
    numInput.addEventListener('input', () => {
      numText.textContent = numInput.value || '00';
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
